module.exports = __webpack_public_path__ + "img/newyear_banner.778cefa8.jpg";